import {extendTheme} from "@chakra-ui/react"
import {MultiSelectTheme} from "chakra-multiselect"


const formStyles = {
    parts: ["container"],
    baseStyle: {
        container: {
            label: {
                color: "gray.900",
                fontWeight: "medium",
                fontSize: "sm"
            },
        },
    },
}


export const theme = extendTheme({
    styles: {
        global: {
            body: {
                bg: "gray.100",
            }
        }
    },
    components: {
        Form: formStyles,
        MultiSelect: MultiSelectTheme
    },
    colors: {
        rainbow: "-webkit-linear-gradient(left, #20BF55, #01baef, #0072C8, #ff9800, #F44336)"
    }
})